<template>
    <div class="api-subscribe-wrap">
      <!-- 查询筛选 -->
      <div class="search-card">
        <el-form :model="queryForm" inline>
          <el-form-item label="机构名称">
            <el-input
              v-model="queryForm.companyName"
              placeholder="输入机构名称"
              clearable
              @keyup.enter="getMainList"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getMainList">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
  
      <!-- 企业主账号表格 -->
      <div class="table-card">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width:100%"
        >
          <el-table-column label="ID" prop="id" align="center" width="80" />
  
          <el-table-column label="机构名称" prop="company_name" align="center" min-width="260" />
          <el-table-column label="操作" align="center" width="180">
            <template #default="scope">
              <el-button type="primary" link @click="openSubscribeDialog(scope.row)">
                编辑API订阅
              </el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          v-model:current-page="pagination.page"
          v-model:page-size="pagination.pageSize"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="getMainList"
          @current-change="getMainList"
          class="mt-4"
        />
      </div>
  
      <!-- 编辑API订阅弹窗 -->
      <el-dialog
        v-model="subscribeDialogVisible"
        title="编辑API订阅"
        width="760px"
        :close-on-click-modal="false"
        @open="dialogOpened"
      >
        <el-form label-width="110px">
          <el-form-item label="当前机构">
            <el-input v-model="currentRow.company_name" disabled />
          </el-form-item>
        </el-form>
  
        <el-divider content-position="left">已订阅API服务</el-divider>
        <div v-loading="dialogLoading" class="subscribe-list-block">
          <div v-if="subscribeApiList.length === 0" class="empty-tip">暂无已订阅API</div>
          <el-table :data="subscribeApiList" border size="small" style="width:100%" v-else>
            <el-table-column label="订阅ID" prop="id" align="center" width="90" />
            <el-table-column label="商品ID" prop="good_id" align="center" width="90" />
            <el-table-column label="商品名称" align="left" min-width="180">
              <template #default="scope">
                {{ getGoodNameById(scope.row.good_id) }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="110">
              <template #default="scope">
                <el-tag :type="getStateTag(scope.row.state)">
                  {{ getStateText(scope.row.state) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="价格(元)" prop="price" align="center" width="100" />
            <el-table-column label="创建时间" prop="create_time" align="center" width="170" />
            <el-table-column label="操作" align="center" width="220">
              <template #default="scope">
                <el-button type="primary" link size="small" @click="openEditRow(scope.row)">
                  修改
                </el-button>
                <el-button type="danger" link size="small" @click="handleDelSubscribe(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <el-divider content-position="left">新增订阅</el-divider>
        <el-form ref="addFormRef" :model="addForm" label-width="110px">
          <el-form-item label="选择API商品" prop="goodsId">
            <el-select v-model="addForm.goodsId" placeholder="请选择API商品" style="width:100%">
              <el-option
                v-for="opt in filterGoodOptions"
                :key="opt.id"
                :label="opt.name"
                :value="opt.id"
              />
            </el-select>
            <div v-if="filterGoodOptions.length === 0" style="color:#999;font-size:12px;margin-top:4px;">
              该机构已订阅全部可用API
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="success" :loading="addLoading" @click="handleAddSubscribe" :disabled="filterGoodOptions.length === 0">新增订阅</el-button>
          </el-form-item>
        </el-form>
  
        <!-- 修改订阅弹窗（内嵌） -->
        <el-dialog v-model="editDialogVisible" title="修改订阅信息" width="480px">
          <el-form :model="editForm" label-width="100px">
            <el-form-item label="订阅状态">
              <el-select v-model="editForm.state" style="width:100%">
                <el-option label="正常" :value="1"/>
                <el-option label="待审核" :value="2"/>
                <el-option label="用户自停用" :value="3"/>
                <el-option label="限制使用" :value="4"/>
              </el-select>
            </el-form-item>
            <el-form-item label="价格">
              <el-input-number v-model="editForm.price" :min="0" style="width:100%"/>
            </el-form-item>
          </el-form>
          <template #footer>
            <el-button @click="editDialogVisible=false">取消</el-button>
            <el-button type="primary" :loading="editLoading" @click="handleSaveEdit">保存</el-button>
          </template>
        </el-dialog>
  
        <template #footer>
          <el-button @click="subscribeDialogVisible = false">关闭</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted, computed } from "vue";
  import { ElMessage, ElMessageBox } from "element-plus";
  import { getmainlist, getsublist, getlist, addsub, upsub } from "@/api/api";
  
  const loading = ref(false);
  const dialogLoading = ref(false);
  const addLoading = ref(false);
  const editLoading = ref(false);
  
  const queryForm = reactive({
    companyName: ""
  });
  
  const pagination = reactive({
    page: 1,
    pageSize: 10,
    total: 0
  });
  
  const tableData = ref([]);
  const subscribeDialogVisible = ref(false);
  const currentRow = ref({});
  const subscribeApiList = ref([]);
  const addFormRef = ref(null);
  const addForm = reactive({
    goodsId: null
  });
  
  //全部可订阅商品，由 getlist 接口加载
  const allGoodOptions = ref([]);
  
  //计算属性：过滤掉已经订阅过的商品，新增下拉只展示未订阅
  const filterGoodOptions = computed(() => {
    const subscribedIds = subscribeApiList.value.map(item => item.good_id);
    return allGoodOptions.value.filter(good => !subscribedIds.includes(good.id));
  });
  
  //编辑弹窗
  const editDialogVisible = ref(false);
  const editForm = reactive({
    id: null,
    state: 1,
    price: 0
  });
  
  //状态映射
  const getStateText = (val) => {
    const map = { 1: "正常", 2: "待审核", 3: "用户自停用", 4: "限制使用" };
    return map[val] || "未知";
  };
  const getStateTag = (val) => {
    const map = { 1: "success", 2: "warning", 3: "danger", 4: "error" };
    return map[val] || "";
  };
  
  //根据good_id获取商品名称
  const getGoodNameById = (goodId) => {
    const find = allGoodOptions.value.find(item => item.id === goodId);
    return find ? find.name : "未知商品";
  };
  
  //获取企业主列表
  const getMainList = async () => {
    loading.value = true;
    try {
      const params = {
        page: pagination.page,
        pageSize: pagination.pageSize,
        companyName: queryForm.companyName || undefined
      };
      const res = await getmainlist(params);
      if (res.code === 200) {
        tableData.value = res.data.list;
        pagination.total = res.data.total;
      } else {
        ElMessage.error(res?.message || "获取企业列表失败");
      }
    } catch (err) {
      ElMessage.error("获取企业列表异常");
    } finally {
      loading.value = false;
    }
  };
  
  //打开订阅弹窗
  const openSubscribeDialog = (row) => {
    currentRow.value = { ...row };
    subscribeDialogVisible.value = true;
  };
  
  //弹窗打开：1.加载全部可订阅商品 2.加载该机构已订阅
  const dialogOpened = async () => {
    subscribeApiList.value = [];
    addForm.goodsId = null;
    dialogLoading.value = true;
    try {
      //拉取全部可订阅API商品
      const resAllGood = await getlist({});
      if(resAllGood.code === 200){
        allGoodOptions.value = resAllGood.data.list || [];
      }
      //保持原有传参 id = currentRow.value.id
      const data = { id: currentRow.value.id };
      const resSub = await getsublist(data);
      if (resSub.code === 200) {
        subscribeApiList.value = resSub.data.list || [];
      }
    } catch (e) {
      ElMessage.error("读取订阅数据失败");
    } finally {
      dialogLoading.value = false;
    }
  };
  
  //新增订阅，保持后端真实字段 goodid
  const handleAddSubscribe = async () => {
    if (!addForm.goodsId) {
      ElMessage.warning("请选择API商品");
      return;
    }
    addLoading.value = true;
    try {
      const payload = {
        id: currentRow.value.id,
        goodid: addForm.goodsId
      };
      const res = await addsub(payload);
      if (res.code === 200) {
        ElMessage.success(res.message || "新增订阅成功");
        dialogOpened();
      } else {
        ElMessage.error(res?.message || "新增订阅失败");
      }
    } catch (e) {
      ElMessage.error("接口请求异常");
    } finally {
      addLoading.value = false;
    }
  };
  
  //打开编辑行
  const openEditRow = (row) => {
    editForm.id = row.id;
    editForm.state = row.state;
    editForm.price = row.price;
    editDialogVisible.value = true;
  };
  
  //保存修改 upsub({id:订阅ID, state, price})
  const handleSaveEdit = async () => {
    editLoading.value = true;
    try {
      const payload = {
        id: editForm.id,
        state: editForm.state,
        price: editForm.price
      };
      const res = await upsub(payload);
      if(res.code === 200){
        ElMessage.success(res.message || "修改成功");
        editDialogVisible.value = false;
        dialogOpened();
      }else{
        ElMessage.error(res?.message || "修改失败");
      }
    } catch (e) {
      ElMessage.error("接口请求异常");
    } finally {
      editLoading.value = false;
    }
  };
  
  //删除订阅：复用upsub，把state置为3（用户自停用）；无delete接口
  const handleDelSubscribe = (row) => {
    ElMessageBox.confirm(
      `确定要删除该订阅记录(good_id:${row.good_id})？操作后机构将无法调用该API！`,
      "风险提示",
      { confirmButtonText: "确认", cancelButtonText: "取消", type: "warning" }
    ).then(async () => {
      const res = await upsub({
        id: row.id,
        state: 3,
        price: row.price
      });
      if(res.code === 200){
        ElMessage.success(res.message || "已停用该订阅");
        dialogOpened();
      }else{
        ElMessage.error(res?.message || "操作失败");
      }
    }).catch(() => {});
  };
  
  const handleReset = () => {
    queryForm.companyName = "";
    pagination.page = 1;
    getMainList();
  };
  
  onMounted(() => {
    getMainList();
  });
  </script>
  
  <style scoped>
  .api-subscribe-wrap {
  }
  .search-card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 16px;
  }
  .table-card {
    background: #fff;
    padding: 16px;
    border-radius: 6px;
  }
  .mt-4 {
    margin-top: 16px;
  }
  .subscribe-list-block {
    min-height:120px;
    padding:8px 0;
  }
  .empty-tip {
    text-align:center;
    color:#999;
    padding:30px 0;
  }
  </style>
  